import React, { useMemo } from 'react';
import { Alert } from '@bedrock/components';
import { PartnershipFlowDetail } from '@purchase/oaflow';
import { isDevOrTest } from '@mpc/common/src/utils/datracker';
import { getCurSupplier } from '../../../Main/MPCLayout/utils';
import './index.less';
import { supplierEnums } from '@purchase/supplier';

const OnBoard = (props: any) => {
  const { vendorProcessAudit, suppliersList } = props;
  const { onboarded, vendorProcessAuditStatus } = vendorProcessAudit || {};
  const { vendorName } = getCurSupplier(suppliersList);

  const alertTitle = useMemo(() => {
    const obj: Record<string, string> = {
      [supplierEnums.VendorProcessAuditStatusEnum.BOARDING_AUDIT]: '以下注册信息已提交,正在审批中，请耐心等待！',
    };
    return obj[vendorProcessAuditStatus] || '';
  }, [vendorProcessAuditStatus]);

  return (
    <div className="out-company-on-board">
      <div className="out-company-on-board-title">{onboarded ? vendorName : '完善企业信息'}</div>
      {alertTitle && <Alert className="m-[16px] mb-[0px]" message={alertTitle} type="info" />}
      <div className="mt-[-16px]">
        <PartnershipFlowDetail
          env={isDevOrTest() ? 'test' : 'prod'}
          solarToken={props.solarToken}
          oaNo={props.oaNo}
          onSubmitSuccess={() => {
            window.location.reload();
          }}
          customScrollContainer={document.querySelector('.b-eed-layout-main-content')}
          actionsFilter={(e) => ['tempSave', 'submit'].includes(e?.action)}
        />
      </div>
    </div>
  );
};

export default OnBoard;
